<template>
	<table class="table-main history">
		<tr>
			<th>리비전</th>
			<th>제품ID</th>
			<th>제품명</th>
			<th>Action</th>
		</tr>

		<tr
			v-for="(product, i) in params.productGroupList"
			:key="product.idProduct"
			:class="{ bold: params.idProduct == product.idProduct }"
		>
			<td>v{{ i }}</td>
			<td>{{ product.idProduct }}</td>
			<td>{{ product.productTitle }}</td>
			<td>
				<a
					v-if="params.idProduct != product.idProduct"
					:href="`/product/product-inquiry/${product.idProduct}`"
					class="btn"
				>
					바로가기
				</a>
			</td>
		</tr>
	</table>
</template>

<script>
	export default {
		name: 'ProductGroup',
		props: {
			params: {
				type: Object,
				default: () => {},
			},
		},
	};
</script>
<style lang="scss" scoped>
	tr.bold {
		font-weight: bold;
	}
</style>
